import { useEffect } from 'react'

import { ShippingTypesSelector } from './ShippingTypesSelector'
import { useAppSelector } from '../../../common/hooks'

import { StyledSelectionContainer, StyledTitle } from './styles/ShippingTypes.style'
import { useInView } from 'react-intersection-observer'
import gtm from '../../../common/gtmTracker'

export const ShippingTypes = () => {
  const { ref, inView } = useInView({ threshold: 0.6 })
  const { merchantCode, clubberEmail } = useAppSelector((state) => state.session)

  useEffect(() => {
    if (inView) {
      gtm.triggerShippingTypesImpression(merchantCode, clubberEmail)
    }
  }, [inView])

  return (
    <StyledSelectionContainer ref={ref}>
      <StyledTitle>Frete:</StyledTitle>
      <ShippingTypesSelector />
    </StyledSelectionContainer>
  )
}
